import { GetStaticProps, InferGetStaticPropsType, NextPage } from 'next';

import {
  FooterDocument,
  FooterQuery,
  FooterQueryVariables,
  NavigationDocument,
  NavigationQuery,
  NavigationQueryVariables,
  SupplierPortalDocument,
  SupplierPortalQuery,
  SupplierPortalQueryVariables,
} from '@/api';
import { addApolloState, initializeApollo } from '@/api/apolloClient';
import { Layout } from '@/components/layout/Layout';
import { Seo } from '@/components/Seo';
import EnhancedPolicyPageWrapper from '@/components/shared/EnhancedPolicyPageWrapper';

export const getStaticProps: GetStaticProps = async () => {
  const client = initializeApollo();

  // prefetch
  await client.query({ query: NavigationDocument });
  await client.query({ query: SupplierPortalDocument });
  await client.query({ query: FooterDocument });

  const { data: footerData } = await client.query<
    FooterQuery,
    FooterQueryVariables
  >({ query: FooterDocument });

  const { data: headerData } = await client.query<
    NavigationQuery,
    NavigationQueryVariables
  >({ query: NavigationDocument });

  const { data: supplierPortalData } = await client.query<
    SupplierPortalQuery,
    SupplierPortalQueryVariables
  >({
    query: SupplierPortalDocument,
  });

  return addApolloState(client, {
    props: {
      footerData,
      headerData,
      supplierPortalData,
    },
  });
};

const SupplierPortal: NextPage<
  InferGetStaticPropsType<typeof getStaticProps>
> = ({ footerData, headerData, supplierPortalData }) => (
  <Layout invertedColor footerData={footerData} headerData={headerData}>
    <Seo seo={supplierPortalData.supplierPortal.data?.attributes?.seo} />
    <EnhancedPolicyPageWrapper
      data={supplierPortalData.supplierPortal.data?.attributes?.policies}
    />
  </Layout>
);

export default SupplierPortal;
